'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var keyPaths = {
  AGENT_TYPE: ['metadata', 'agentType'],
  AGENT_ID: ['metadata', 'agentId'],
  ASSIGNED_BY_METHOD: ['metadata', 'assignedByMethod'],
  ASSIGNED_BY_AGENT_TYPE: ['metadata', 'assignedByAgentType'],
  ASSIGNED_BY_AGENT_ID: ['metadata', 'assignedByAgentId'],
  ASSIGNED_AGENT_ID: ['metadata', 'assignedAgent', 'agentId'],
  ASSIGNED_AGENT_TYPE: ['metadata', 'assignedAgent', 'agentType']
};
exports.default = keyPaths;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/assignment-message/keyPaths.js
// module id = 811
// module chunks = 2 3